import React from 'react'
import { DispatchProp,connect } from 'react-redux'
import { notification_dismiss } from '../state/actions'
import { State } from '../store'
import { Notification as NotificationType } from '../types'
import CIcon from '@coreui/icons-react'
import { cilX } from '@coreui/icons-pro'

type _props =
{
  notification:NotificationType
}
type Props = _props & DispatchProp<any>
class Notification extends React.Component<Props>
{
  dismiss()
  {
    this.props.dispatch(notification_dismiss(this.props.notification.id))
  }
  componentDidMount()
  {
    setTimeout(() => {
      this.dismiss()
    },3 * 1000)
  }
  render()
  {
    return this.props.notification.dismissed ? null : (
      <div className="growler card bg-info p-2">
        <div className="d-flex justify-content-between mb-1">
          <div className="mr-4">
            <strong>Success</strong>
            <div key={ this.props.notification.id }>{ this.props.notification.message }</div>
          </div>
          <button className="btn btn-link btn-small dismiss text-muted" onClick={ () => this.dismiss() }><CIcon content={ cilX }/></button>
        </div>
      </div>
    )
  }
}

export default connect((_state:State) => ({
}))(Notification)
